import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { TradeDiscountPopup } from '../../../../../cartAndOrders/common/poup/TradeDiscountPopup'
import {
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectVoucher,
} from '../../../../../cartAndOrders/store/slice'

import { CHECKBOX_TRADE_DISCOUNT } from '../../../../../cartAndOrders/constant'
import { Element } from '../../../../../common/html/element'

export const SelectOrEnterCode = ({
  price,
  discountOther,
  isDiscount = false,
  priceDiscountDetails,
}) => {
  const [isOpenDiscount, setIsOpenDiscount] = useState(false)

  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)

  const dataVoucher = useSelector(selectVoucher)
  const discount = useSelector(selectDiscountOrder)
  const discountOrder = discountOther ? discountOther : discount

  //
  const priceDiscountRaw = discountOrder?.discountPercentage || 0
  const priceVoucher = checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER]
    ? dataVoucher?.discountPercentage
    : 0

  const priceDiscount = price / (priceDiscountRaw + priceVoucher)

  const openPopupDiscount = () => {
    setIsOpenDiscount(true)
  }
  const closePopupDiscount = () => {
    setIsOpenDiscount(false)
  }

  return (
    <>
      <Element
        elementName="span"
        style={{
          color: '#2C73E8',
          fontStyle: 'italic',
          marginLeft: 'auto',
          cursor: 'pointer',
        }}
        className="dFlex alignItemsCenter"
        onClick={openPopupDiscount}
      >
        <Translate value="userManagement.buyPackage.SELECT_ENTER_CODE" />
      </Element>

      <TradeDiscountPopup
        isShow={isOpenDiscount}
        onClose={closePopupDiscount}
        pricePackage={priceDiscount}
        isDiscount={isDiscount}
        priceDiscountDetails={priceDiscountDetails}
      />
    </>
  )
}
